import { number, string } from 'prop-types';
import React from 'react';
import { colors } from '@ajaibid/components';

const IconInfo = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9999 3.66683C6.94983 3.66683 3.66659 6.95007 3.66659 11.0002C3.66659 15.0503 6.94983 18.3335 10.9999 18.3335C15.05 18.3335 18.3333 15.0503 18.3333 11.0002C18.3333 6.95007 15.05 3.66683 10.9999 3.66683ZM1.83325 11.0002C1.83325 5.93755 5.93731 1.8335 10.9999 1.8335C16.0625 1.8335 20.1666 5.93755 20.1666 11.0002C20.1666 16.0628 16.0625 20.1668 10.9999 20.1668C5.93731 20.1668 1.83325 16.0628 1.83325 11.0002Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9999 10.0835C11.5062 10.0835 11.9166 10.4939 11.9166 11.0002V15.5835C11.9166 16.0898 11.5062 16.5002 10.9999 16.5002C10.4937 16.5002 10.0833 16.0898 10.0833 15.5835V11.0002C10.0833 10.4939 10.4937 10.0835 10.9999 10.0835Z"
      fill={color}
    />
    <path
      d="M12.3749 6.87516C12.3749 7.63455 11.7593 8.25016 10.9999 8.25016C10.2405 8.25016 9.62492 7.63455 9.62492 6.87516C9.62492 6.11577 10.2405 5.50016 10.9999 5.50016C11.7593 5.50016 12.3749 6.11577 12.3749 6.87516Z"
      fill={color}
    />
  </svg>
);

IconInfo.propTypes = {
  color: string,
  size: number,
};

IconInfo.defaultProps = {
  color: colors.NEUTRAL_10,
  size: 22,
};

export default IconInfo;
